import { useEnvironment } from '@wix/yoshi-flow-editor';
import React from 'react';
import { useDailyAgendaActions } from '../../../../../components/DailyAgenda/hooks/useDailyAgendaActions';
import { AgendaItemViewModel } from '../../../../../components/DailyAgenda/viewModel/agendaViewModel/agendaViewModel';
import { LayoutTypes } from '../../../../../types/types';
import { classes, st } from './AgendaItem.st.css';
import { agendaItemLayoutFactory } from './AgendaItemLayoutFactory';
import {
  WidgetComponents,
  WidgetElements,
} from '../../../../../utils/bi/consts';

export type AgendaItemProps = {
  layoutType: LayoutTypes;
  agendaItemViewModel: AgendaItemViewModel;
};

export const AgendaItem: React.FC<AgendaItemProps> = ({
  layoutType,
  agendaItemViewModel,
}) => {
  const { onSlotClick, onElementClicked } = useDailyAgendaActions();
  const { isMobile } = useEnvironment();
  const RenderAgendaItemLayout = agendaItemLayoutFactory[layoutType];

  const handleSlotClick = (slotId: string): Promise<void> => {
    onElementClicked(WidgetComponents.AGENDA_ITEM, WidgetElements.BOOK_BUTTON);
    return onSlotClick(slotId);
  };

  return (
    <div className={st(classes.root, { layoutType, isMobile })}>
      <RenderAgendaItemLayout
        key={agendaItemViewModel.slotId}
        onSlotClick={handleSlotClick}
        agendaItemViewModel={agendaItemViewModel}
      />
    </div>
  );
};
